import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { IBasePopupTrigger, PopupTriggerContext } from '../BasePopupTrigger';
import {
  getPopupModalCookieName,
  hasPopupAlreadyShown,
  setPopupShown,
} from '../PopUpTriggerStorage';

type TimerTriggerFields = Feature.EnterpriseWeb.Enterprise.Elements.Modal.TimerTrigger['fields'];

export class TimerTrigger implements IBasePopupTrigger {
  private fields: TimerTriggerFields;

  constructor({ triggerFieldsProps }: { triggerFieldsProps: TimerTriggerFields }) {
    this.fields = triggerFieldsProps;
  }

  register({ popupId, onTrigger }: PopupTriggerContext) {
    const timingLength = this.fields?.timingLength?.value || 0;
    const cookieName = getPopupModalCookieName(popupId);

    if (typeof window === 'undefined' || hasPopupAlreadyShown(cookieName) || timingLength <= 0) {
      return;
    }

    const timer = window.setTimeout(() => {
      if (hasPopupAlreadyShown(cookieName)) {
        return;
      }

      setPopupShown(cookieName);
      onTrigger();
    }, timingLength * 1000);

    return () => {
      window.clearTimeout(timer);
    };
  }
}
